__turbopack_context__.v({
  "fusionSection": "So2xga_fusionSection",
  "fusionSectionCaption": "So2xga_fusionSectionCaption",
  "fusionSectionContent": "So2xga_fusionSectionContent",
  "fusionSectionPadding": "So2xga_fusionSectionPadding",
  "fusionSectionText": "So2xga_fusionSectionText",
  "fusionSectionTitle": "So2xga_fusionSectionTitle",
});
